// const uriClient = "http://localhost:3000"

const uriClient = "https://stupefied-yalow-dbd057.netlify.app"

export default uriClient